export default __webpack_public_path__ + "static/media/Logos_part_transp.18f70770.png";